import { useMyContext } from 'Context/MyContextProvider';
const PermissionChecker = ({ permission, children }) => {
    const { Permisson, userRole } = useMyContext();
    const hasPermission = () => {
        if (userRole === 'Admin') {
            return true;
        }
        return Permisson?.includes(permission);
    }

    if (hasPermission()) {
        return children;
    }

    return null;
}

export default PermissionChecker
